import getMayflyData from '../graphql/getMayflyData'
import getBundleItemsFromCache from '../graphql/getBundleItemsFromCache'
import { log } from './error-tracking'

export async function persistBundle(
  client,
  addToCart,
  cartItems,
  newItems = [],
) {
  const { data } = await addToCart({
    variables: {
      cartInfo: { cartItems, newItems },
    },
  })

  localStorage.setItem('bundle_id', data.addToCart.cart_id)

  try {
    const { data: _data } = await client.query({
      query: getMayflyData,
      variables: { mfKey: data.addToCart.cart_id },
    })

    const sanitizedCart = _data.getMayflyData

    client.writeQuery({
      query: getBundleItemsFromCache,
      data: { bundleItems: sanitizedCart },
    })

    return sanitizedCart
  } catch (err) {
    log({
      file: 'product-page',
      err: { stack: 'Graphql error in addToBundle ' + err.message },
    })

    return cartItems
  }
}
